import { useTranslation } from "react-i18next";

import DateTime from "components/DateTime";

import { DateAtProps } from "./types";

const DateAt = ({ title, date }: DateAtProps) => {
    const { t } = useTranslation();

    return (
        <>
            <span>{t(`Table##${title}`)}:</span>

            <span>
                <DateTime date={date} format="L" />
            </span>
        </>
    );
};

export default DateAt;
